import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// ui icons
import Assignment from "@material-ui/icons/Assignment";

// ui components
import Slide from "@material-ui/core/Slide";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// core components 
import Card from "beaktShared/components/Card/Card.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import IdentificacaoCampanha from './Componentes/IdentificacaoCampanha';
import VisualizacaoCampanha from './Componentes/VisualizacaoCampanha';
import ConclusaoCampanha from './Componentes/ConclusaoCampanha';

// styles
import { makeStyles } from "@material-ui/core/styles";
// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function GestaoCampanhaForm({addItem, itemcampanha, handleView, disableform }) {
    const { t } = useTranslation();
    const classes = useStyles();

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };
    const [campanha, set_campanha] = React.useState(null);
    const [step, set_step] = React.useState(null);

    useEffect(() => {
        set_campanha(itemcampanha);
        set_step(0);
    }, [itemcampanha]);

    const handleProximoStep = (_campanha) => {
        if (step == 2)
        {

        }
        else{
            set_campanha(_campanha);
            set_step(step+1);
        }
    }

    const handleStepAnterior = (_campanha) => {
        set_campanha(_campanha)
        set_step(step-1);
    }

    const handleCancelar = () => {
        handleView(false)
    }

    const handleFinalizar = (_itemCampanha) => {
        addItem(_itemCampanha);
    }

    return (

        <div>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification({ show: false })}
                close
            />
            <GridContainer className="no-print">
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('sidebar.campaign_registrations')} </h4>
                        </CardHeader>
                        <CardBody>

                        {step == 0 && <IdentificacaoCampanha item={campanha} handleCancelar={handleCancelar} handleProximoStep={handleProximoStep} disabledform={disableform}></IdentificacaoCampanha>}
                        {step == 1 && <VisualizacaoCampanha item={campanha} handleProximoStep={handleProximoStep} handleStepAnterior={handleStepAnterior} disabledform={disableform} ></VisualizacaoCampanha>}
                        {step == 2 && <ConclusaoCampanha item={campanha}  handleFinalizar={handleFinalizar} handleStepAnterior={handleStepAnterior} disabledform={disableform} ></ConclusaoCampanha>}

                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}

